const CartStore = {
    state: {
        id: null,
        items: [],
        pricing: {
            version: null,
            revision: null,
            plan: null
        },
        date: {
            expired: null,
            periodStart: null,
            periodStop: null
        },
        earlyRenewal: false,
        earlyRenewalDiscount: 0,
        context: null,
        source: null,
        payment: {
            method: null,
            facility: 1
        },
        saved: {
            total: false,
            items: [],
            pricing: {
                version: null,
                revision: null,
                plan: null
            },
            date: {
                expired: null,
                periodStart: null,
                periodStop: null
            },
            earlyRenewal: false,
            context: null,
            source: null,
            payment: {
                method: null,
                facility: 1
            },
            status: null
        },
        paymentIntent: {},
        totalFromPaymentIntent: {},
        isExpired: false,
        isCancelable: false,
        contactAdded: null,
        contactName: null,
        contactMailAddress: null,
        contactPhone: null,
    },
    mutations: {
        setCartId(state, data) { state.id = data },
        setCartItems(state, payload) { payload.context == "saved" ? state.saved.items = payload.data : state.items = payload.data },
        setCartContext(state, payload) { payload.context == "saved" ? state.saved.context = payload.data : state.context = payload.data },
        setCartPaymentMethod(state, payload) { payload.context == "saved" ? state.saved.payment.method = payload.data : state.payment.method = payload.data },
        setCartPaymentFacility(state, payload) { payload.context == "saved" ? state.saved.payment.facility = payload.data : state.payment.facility = payload.data },
        setCartPeriodStart(state, payload) { payload.context == "saved" ? state.saved.date.periodStart = payload.data : state.date.periodStart = payload.data },
        setCartPeriodStop(state, payload) { payload.context == "saved" ? state.saved.date.periodStop = payload.data : state.date.periodStop = payload.data },
        setCartExpiration(state, payload) { payload.context == "saved" ? state.saved.date.expired = payload.data : state.date.expired = payload.data },
        setCartEarlyRenewal(state, payload) { payload.context == "saved" ? state.saved.earlyRenewal = payload.data : state.earlyRenewal = payload.data },
        setCartEarlyRenewalDiscount(state, payload) { payload.context == "saved" ? state.saved.earlyRenewalDiscount = payload.data : state.earlyRenewalDiscount = payload.data },
        setCartContactAdded(state, payload) { payload.contactAdded == "saved" ? state.saved.contactAdded = payload.data : state.contactAdded = payload.data },
        setCartContactName(state, payload) { payload.contactName == "saved" ? state.saved.contactName = payload.data : state.contactName = payload.data },
        setCartContactMailAddress(state, payload) { payload.contactMailAddress == "saved" ? state.saved.contactMailAddress = payload.data : state.contactMailAddress = payload.data },
        setCartContactPhone(state, payload) { payload.contactPhone == "saved" ? state.saved.contactPhone = payload.data : state.contactPhone = payload.data },
        setCart(state, payload) { 
            state.id = payload.data.id;
            state.isExpired = payload.data.isExpired;
            state.isCancelable = payload.data.isCancelable;
            if (payload.context == "saved") {
                state.saved.pricing.version = payload.data.pricingVersion;
                state.saved.pricing.revision = payload.data.pricingVersionRevision;
                state.saved.pricing.plan = payload.data.pricingPlanId;
                state.saved.date.expired = payload.data.expirationDate;
                state.saved.date.periodStart = payload.data.periodApplianceStart;
                state.saved.date.periodStop = payload.data.periodApplianceStart;
                state.saved.context = payload.data.context;
                state.saved.source = payload.data.source;
                state.saved.payment.method = payload.data.paymentMethod;
                state.saved.payment.facility = payload.data.paymentFacility;
                state.saved.status = payload.data.statusCode;
                state.saved.earlyRenewal = payload.data.earlyRenewal;
                state.saved.earlyRenewalDiscount = payload.data.creditNoteAmount;
                state.saved.contactAdded = payload.data.contactAdded;
                state.saved.contactName = payload.data.contactName;
                state.saved.contactMailAddress = payload.data.contacMailAddress;
                state.saved.contactPhone = payload.data.contactPhone;
            } else {
                state.pricing.version = payload.data.pricingVersion;
                state.pricing.revision = payload.data.pricingVersionRevision;
                state.pricing.plan = payload.data.pricingPlanId;
                state.date.expired = payload.data.expirationDate;
                state.date.periodStart = payload.data.periodApplianceStart;
                state.date.periodStop = payload.data.periodApplianceStart;
                state.context = payload.data.context;
                state.source = payload.data.source;
                state.payment.method = payload.data.paymentMethod;
                state.payment.facility = payload.data.paymentFacility;
                state.earlyRenewal = payload.data.earlyRenewal;
                state.earlyRenewalDiscount = payload.data.creditNoteAmount;
                state.contactAdded = payload.data.contactAdded;
                state.contactName = payload.data.contactName;
                state.contactMailAddress = payload.data.contacMailAddress;
                state.contactPhone = payload.data.contactPhone;
            }
        },
        // saved
        setCartSavedTotal(state, data) { state.saved.total = data },
        setCartSaved(state, payload) {
            state.saved.pricing.version = payload.pricingVersion;
            state.saved.pricing.revision = payload.pricingVersionRevision;
            state.saved.pricing.plan = payload.pricingPlanId;
            state.saved.date.expired = payload.expirationDate;
            state.saved.date.periodStart = payload.periodApplianceStart;
            state.saved.date.periodStop = payload.periodApplianceStart;
            state.saved.context = payload.context;
            state.saved.source = payload.source;
            state.saved.payment.method = payload.paymentMethod;
            state.saved.payment.facillity = payload.paymentFacility;
        },
        setCartSavedStatus(state, data) { state.saved.status = data },
        // paymentIntent
        setPaymentIntent(state, data) { state.paymentIntent = data },
        setPaymentIntentTotal(state, data) { state.totalFromPaymentIntent = data },

        setCartIsExpired(state, data) { state.isExpired = data },
        setCartIsCancelable(state, data) { state.isCancelable = data },
    },
    actions: {
        defineCartId({ commit }, value) { commit("setCartId", value) },
        defineCartItems({ commit }, payload) { commit("setCartItems", payload) },
        defineCartContext({ commit }, payload) { commit("setCartContext", payload) },
        defineCart({ commit }, payload) { commit("setCart", payload) },
        defineCartContactAdded({ commit }, payload) { commit("setCartContactAdded", payload) },
        defineCartContactName({ commit }, payload) { commit("setCartContactName", payload) },
        defineCartContactMailAddress({ commit }, payload) { commit("setCartContactMailAddress", payload) },
        defineCartContactPhone({ commit }, payload) { commit("setCartContactPhone", payload) },
        defineCartPaymentMethod({ commit }, payload) { commit("setCartPaymentMethod", payload) },
        defineCartPaymentFacility({ commit }, payload) { commit("setCartPaymentFacility", payload) },
        defineCartPeriodStart({ commit }, payload) { commit("setCartPeriodStart", payload) },
        defineCartPeriodStop({ commit }, payload) { commit("setCartPeriodStop", payload) },
        defineCartExpiration({ commit }, payload) { commit("setCartExpiration", payload) },
        // saved
        defineSavedCartTotal({ commit }, value) { commit("setCartSavedTotal", value) },
        defineSavedCartStatus({ commit }, value) { commit("setCartSavedStatus", value) },
        // paymentIntent
        definePaymentIntent({ commit }, value) { commit("setPaymentIntent", value) },
        definePaymentIntentTotal({ commit }, value) { commit("setPaymentIntentTotal", value) },

        defineCartisExpired({ commit }, value) { commit("setCartIsExpired", value) },
        defineCartIsCancelable({ commit }, value) { commit("setIsCancelable", value) },
    },
    getters: {
        cartId: state => state.id,
        cartItems: state => fromSave => !!fromSave ? state.saved.items : state.items,
        cartPricing: state => fromSave => !!fromSave ? state.saved.pricing : state.pricing,
        cartExpiredDate: state => fromSave => !!fromSave ? state.saved.date.expired : state.date.expired,
        cartEarlyRenewal: state => fromSave => !!fromSave ? state.saved.earlyRenewal : state.earlyRenewal,
        cartContactAdded: state => fromSave => !!fromSave ? state.saved.contactAdded : state.contactAdded,
        cartContactName: state => fromSave => !!fromSave ? state.saved.contactName : state.contactName,
        cartContactMailAddress: state => fromSave => !!fromSave ? state.saved.contactMailAddress : state.contactMailAddress,
        cartContactPhone: state => fromSave => !!fromSave ? state.saved.contactPhone : state.contactPhone,
        cartPeriodStartDate: state => fromSave => !!fromSave ? state.saved.date.periodStart : state.date.periodStart,
        cartPeriodStopDate: state => fromSave => !!fromSave ? state.saved.date.periodStop : state.date.periodStop,
        cartContext: state => fromSave => !!fromSave ? state.saved.context : state.context,
        cartSource: state => fromSave => !!fromSave ? state.saved.source : state.source,
        cartPaymentMethod: state => fromSave => !!fromSave ? state.saved.payment.method : state.payment.method,
        cartPaymentFacility: state => fromSave => !!fromSave ? state.saved.payment.facility : state.payment.facility,
        cartSavedTotal: state => state.saved.total,
        cartSavedStatus: state => state.saved.status,
        cartPaymentIntent: state => state.paymentIntent,
        cartPaymentIntentTotal: state => state.totalFromPaymentIntent,
        cartIsExpired: state => state.isExpired,
        cartIsCancelable: state => state.isCancelable,
    }
}

export default CartStore;